export default __webpack_public_path__ + "static/media/scholar_1.50848d7f.jpg";